import {
  Button,
  Grid,
  GridItem,
  Heading,
  Input,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import getQualificationStatus from "../apiUtils/getQualificationStatus";
import translations from "../content/content";

function IdNumberInput({ language }) {
  const [idNumber, setIdNumber] = useState("");
  const [qualificationStatus, setQualificationStatus] = useState({
    kwalifiseerStatus: "Kwalifiseer nie",
  });
  const [isLoading, setIsLoading] = useState(false);
  const handleCheck = async () => {
    setIsLoading(true);
    var getQualify = await getQualificationStatus(idNumber)
      .then((data) => {
        if(String(data.kwalifiseerStatus).includes("Kwalifiseer nie")) {
            window.location.href= "https://lede.atkv.org.za/ATKVLede/Oorde/oordeKN.aspx"
        }
        else {
            window.location.href= "https://lede.atkv.org.za/ATKVLede/Oorde/oordeK.aspx"
        }
        setQualificationStatus(data);
        setIsLoading(false);
      })
      .catch((err) => {
        window.alert(err);
        setQualificationStatus({ kwalifiseerStatus: "Kwalifiseer nie" });
        setIsLoading(false);
        
      });
  };

  return (
    <Grid>
      <GridItem m={3}>
        <Heading>{translations[language].heading}</Heading>
      </GridItem>
      <GridItem m={3}>{translations[language].intro}</GridItem>
      <div dangerouslySetInnerHTML={{ __html: translations[language].unsure }}></div>
      <GridItem m={3}>
        <Input
          placeholder={translations[language].inputPlaceholder}
          value={idNumber}
          onChange={(e) => setIdNumber(e.target.value)}
        />
      </GridItem>
      <GridItem m={3}>
        <Button onClick={handleCheck}>
          {translations[language].checkStatusButton}
        </Button>
      </GridItem>
      {isLoading ? (
        <Spinner />
      ) : (
<></>
      )}
    </Grid>
  );
}

export default IdNumberInput;
